{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} бесед выбрано",
    "AGENT_SELECT_LABEL": "Выбрать Агента",
    "ASSIGN_CONFIRMATION_LABEL": "Вы уверены, что хотите назначить {conversationCount} {conversationLabel}",
    "UNASSIGN_CONFIRMATION_LABEL": "Вы уверены, что хотите отменить назначение {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Вернуться",
    "ASSIGN_LABEL": "Назначить",
    "YES": "Да",
    "SEARCH_INPUT_PLACEHOLDER": "Поиск",
    "ASSIGN_AGENT_TOOLTIP": "Назначить агента",
    "ASSIGN_TEAM_TOOLTIP": "Назначить команду",
    "ASSIGN_SUCCESFUL": "Беседы успешно назначены.",
    "ASSIGN_FAILED": "Не удалось назначить диалоги, попробуйте еще раз.",
    "RESOLVE_SUCCESFUL": "Беседы успешно завершены.",
    "RESOLVE_FAILED": "Не удалось завершить диалоги, попробуйте еще раз.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Беседы, видимые на этой странице, выбраны.",
    "AGENT_LIST_LOADING": "Загрузка агентов",
    "UPDATE": {
      "CHANGE_STATUS": "Изменить статус",
      "SNOOZE_UNTIL": "Отложено",
      "UPDATE_SUCCESFUL": "Статус беседы успешно обновлен.",
      "UPDATE_FAILED": "Не удалось обновить диалоги, попробуйте еще раз."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Назначить метки",
      "NO_LABELS_FOUND": "Нет меток для",
      "ASSIGN_SELECTED_LABELS": "Назначить выбранные метки",
      "ASSIGN_SUCCESFUL": "Метки успешно назначены.",
      "ASSIGN_FAILED": "Не удалось назначить метки, пожалуйста, попробуйте снова."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Выберите команду",
      "NONE": "Ничего",
      "NO_TEAMS_AVAILABLE": "Нет команд, добавленных в этот аккаунт.",
      "ASSIGN_SELECTED_TEAMS": "Назначить выбранную команду.",
      "ASSIGN_SUCCESFUL": "Команды, назначены успешно.",
      "ASSIGN_FAILED": "Не удалось назначить команду, попробуйте еще раз."
    },
    "MERGE": {
      "TOOLTIP": "Объединить диалоги",
      "TITLE": "Объединить диалоги",
      "DESCRIPTION": "Выберите целевой диалог. Все остальные выбранные диалоги будут объединены с ним — их сообщения будут перенесены в целевой диалог, а диалоги-источники будут удалены.",
      "TARGET_LABEL": "Целевой диалог (будет сохранён)",
      "SOURCES_LABEL": "Диалоги-источники (будут удалены)",
      "SELECT_TARGET": "Выберите диалог в качестве цели объединения",
      "WARNING": "Внимание: это действие нельзя отменить. Сообщения из всех диалогов-источников будут перенесены в целевой диалог, а диалоги-источники будут безвозвратно удалены.",
      "SUBMIT": "Объединить диалоги",
      "CANCEL": "Отменить",
      "SUCCESS_MESSAGE": "Диалоги успешно объединены",
      "ERROR_MESSAGE": "Не удалось объединить диалоги. Попробуйте ещё раз.",
      "CONFIRM": {
        "TITLE": "Подтвердите объединение",
        "DESCRIPTION": "Вы уверены, что хотите объединить {sourceCount} диалогов в #{targetId}? Это действие нельзя отменить.",
        "YES": "Да, объединить",
        "CANCEL": "Отменить"
      }
    }
  }
}
